import { i18next } from '../i18n'
import moment from 'moment'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { getFromSnake } from '@/helpers/functions/getFromSnake'

export function isActiveDataFlag (data) {
  if (!data) {
    return false
  }
  const { active, value } = data
  if (active === false) {
    return false
  }
  if (value === true) {
    return true
  }
  if (value === false || value == null) {
    return false
  }
  if (typeof value === 'number') {
    return value !== 0
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    return normalized !== '' && normalized !== '0' && normalized !== 'false'
  }
  return true
}

export default {
  state: {
    language: i18next.language,
    menuOpened: false,
    user: null,
    sitimmoUser: null,
    token: null,
    countries: [],
    offerTypes: [],
    pickerOptionsShortcuts: [
      {
        text: 'general.calendar.lastWeek',
        onClick (picker) {
          const end = new Date()
          const start = moment().subtract(1, 'weeks').format('YYYY-MM-DD')
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'general.calendar.lastMonth',
        onClick (picker) {
          const end = new Date()
          const start = moment().subtract(1, 'months').format('YYYY-MM-DD')
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'general.calendar.lastThreeMonths',
        onClick (picker) {
          const end = new Date()
          const start = moment().subtract(3, 'months').format('YYYY-MM-DD')
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'general.calendar.lastSixMonths',
        onClick (picker) {
          const end = new Date()
          const start = moment().subtract(6, 'months').format('YYYY-MM-DD')
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'general.calendar.lastTwelveMonths',
        onClick (picker) {
          const end = new Date()
          const start = moment().subtract(1, 'years').format('YYYY-MM-DD')
          picker.$emit('pick', [start, end])
        }
      }
    ],
    produits: null,
    popupSfcVue: false,
    popupBiensVendusVue: false,
    popupMaintenanceJuin2022: true
  },
  getters: {
    getUser: (state) => {
      return state.user
    },
    getSitimmoUser: (state) => {
      return state.sitimmoUser
    },
    getUserRS: (state) => {
      return state.user.socialNetworkIds
    },
    getAdvertiser: (state) => {
      return state.user.advertiser
    },
    getToken: (state) => {
      return state.token
    },
    getMenuOpened: (state) => {
      return state.menuOpened
    },
    hasMultiAccounts: (state) => {
      return state.user.multiAccounts
    },
    isMainAccount: (state, getters) => {
      return (getters.hasMultiAccounts && state.user.mainAccount) || !getters.hasMultiAccounts
    },
    isSubAdmin: (state, getters) => {
      return getters.hasMultiAccounts && state.user.roles.includes('ROLE_SUB_ADMIN')
    },
    isSubUser: (state, getters) => {
      return getters.hasMultiAccounts && state.user.roles.includes('ROLE_SUB_USER')
    },
    getCountries: (state) => {
      return state.countries
    },
    getOfferTypes: (state) => {
      return state.offerTypes
    },
    isImmo: (state) => {
      return state.sitimmoUser && state.sitimmoUser.univers === 'IMMO'
    },
    isVo: (state) => {
      return state.sitimmoUser && state.sitimmoUser.univers === 'VO'
    },
    isPromoteur: (state) => {
      return state.sitimmoUser && state.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmi: (state) => {
      return state.sitimmoUser && state.sitimmoUser.metier === 'CMI'
    },
    isCmiste: (state) => {
      return state.sitimmoUser && state.sitimmoUser.metier === 'CMI'
    },
    isBailleurSocial: (state) => {
      return state.sitimmoUser && state.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isAgence: (state) => {
      return state.sitimmoUser && state.sitimmoUser.metier === 'AGENCE'
    },
    getPickerOptionsShortcuts: (state) => {
      return state.pickerOptionsShortcuts.map(item => ({
        ...item,
        text: i18next.t(item.text)
      }))
    },
    getUniverse: (state) => {
      return state.sitimmoUser.univers
    },
    getJob: (state) => {
      return state.sitimmoUser.metier
    },
    getCodeReseauSfc: (state) => {
      return state.sitimmoUser.codeReseauSfc
    },
    getIdExterneSfc: (state) => {
      return state.sitimmoUser.idExterneSfc
    },
    getStopPopupStatistics: (state) => {
      return state.user.stopPopupStatistics
    },
    getLangage: (state) => {
      return state.language
    },
    getStopPopupBV: (state) => {
      return state.user.stopPopupBiensVendus
    },
    getProduits: (state) => {
      return state.produits
    },
    getPopupSfcVue: (state) => {
      return state.popupSfcVue
    },
    isSoldProductsOption: (state) => {
      return state.sitimmoUser && state.sitimmoUser.soldProductsOption
    },
    saisit_en_ligne: (state) => {
      return getFromSnake(state.sitimmoUser, 'saisitAnnoncesEnLigne') || getFromSnake(state.sitimmoUser, 'saisit_en_ligne_et_flux')
    },
    packExpert: (state) => {
      return state.sitimmoUser && state.sitimmoUser.packDiffusion === 'pack_expert'
    },
    garantiePublication: (state) => {
      return state.sitimmoUser && state.sitimmoUser.garantiePublication === 'true'
    },
    nbStocks: (state) => {
      return state.sitimmoUser && state.sitimmoUser.stocks.length
    },
    stocks: (state) => {
      return state.sitimmoUser && state.sitimmoUser.stocks
    },
    activeData: (state) => {
      if (!state.sitimmoUser || !Array.isArray(state.sitimmoUser.activeData)) {
        return []
      }
      return state.sitimmoUser.activeData
    },
    getActiveDataByCode: (state, getters) => (code) => {
      const found = getters.activeData.find(function (item) {
        return item && item.code === code
      })
      return found || null
    },
    hasMultiUserAdmin: (state, getters) => {
      return isActiveDataFlag(getters.getActiveDataByCode('MULTI_USER_ADMIN'))
    },
    possedeContactManager: (state) => {
      return state.sitimmoUser && getFromSnake(state.sitimmoUser, 'possede_contact_manager')
    },
    isUserDemo: (state) => {
      const agFakedData = ['ag352054', 'ag352055', 'ag352056', 'ag352057']
      return agFakedData.includes(state.sitimmoUser.login)
    },
    IAoptionActive: (state) => {
      return state.sitimmoUser.optionIa
    },
    IAoptionPersonnalisationPromptActive: (state) => {
      return state.sitimmoUser.personnalisationPrompts
    },
    hasOptionIaAndPersoPrompt: (state) => {
      return state.sitimmoUser.optionIa && state.sitimmoUser.personnalisationPrompts
    },
    hasFlux: (state) => {
      return !state.sitimmoUser.optionIa && !state.sitimmoUser.personnalisationPrompts
    },
    possedeClapVideo: (state) => {
      return state.user.possedeClapVideo
    },
    hasPackSocialManager: (state) => {
      return state.sitimmoUser.packSocialManagement !== null
    },
    packSocialManager: (state) => {
      return state.sitimmoUser.packSocialManagement
    },
    hasDiffusionsRs: (state) => {
      return state.user && state.user.socialNetworkCodenames && state.user.socialNetworkCodenames.length > 0
    },
    getDiffusionsRs: (state) => {
      return (state.user && state.user.socialNetworkCodenames) || []
    },
    hasDiffusions: (state) => {
      return state.user && state.user.diffusions && state.user.diffusions.length > 0
    },
    getDiffusions: (state) => {
      return (state.user && state.user.diffusions) || []
    },
    hasRelatedToClassifiedsApi: (state) => {
      return state.sitimmoUser.relatedToClassifiedsApi
    },
    getNbPhotosMaxAnnonce: (state) => {
      return state.sitimmoUser.nbPhotosMaxAnnonce
    }
  },
  mutations: {
    setLanguage (state, language) {
      state.language = language
    },
    setUser (state, user) {
      state.user = user
    },
    setSitimmoUser (state, sitimmoUser) {
      state.sitimmoUser = sitimmoUser
    },
    setToken (state, token) {
      state.token = token
    },
    setMenuOpened (state, menuOpened) {
      state.menuOpened = menuOpened
    },
    setSaveFilters (state, saveFilters) {
      state.saveFilters = saveFilters
    },
    setCountries (state, countries) {
      state.countries = countries
    },
    setOfferTypes (state, offerTypes) {
      state.offerTypes = offerTypes
    },
    setPickerOptionsShortcuts (state, pickerOptionsShortcuts) {
      state.pickerOptionsShortcuts = pickerOptionsShortcuts
    },
    setProduits (state, produits) {
      state.produits = produits
    },
    setPopupSfcVue (state, popupSfcVue) {
      state.popupSfcVue = popupSfcVue
    },
    setPopupBiensVendusVue (state, popupBiensVendusVue) {
      state.popupBiensVendusVue = popupBiensVendusVue
    },
    setPopupStatistics (state, bool) {
      state.user.stopPopupStatistics = bool
    },
    setSocialNetworkIds (state, socialNetworkIds) {
      state.user.socialNetworkIds = socialNetworkIds
    },
    setSocialNetworkCodenames (state, socialNetworkCodenames) {
      state.user.socialNetworkCodenames = socialNetworkCodenames
    },
    SET_STOP_POPUP_BIENS_VENDUS (state, value) {
      state.app.user.stopPopupBiensVendus = value
    }
  },
  actions: {
    // avoid service functions here, only state management
    setLanguage ({ commit }, language) {
      commit('setLanguage', language)
      i18next.changeLanguage(language)
    },
    setUser ({ commit }, user) {
      commit('setUser', user)
    },
    unsetUser ({ commit }) {
      commit('setUser', null)
    },
    setSitimmoUser ({ commit }, sitimmoUser) {
      commit('setSitimmoUser', sitimmoUser)
    },
    unsetSitimmoUser ({ commit }) {
      commit('setSitimmoUser', null)
    },
    setToken ({ commit }, token) {
      commit('setToken', token)
    },
    unsetToken ({ commit }) {
      commit('setToken', null)
    },
    setMenuOpened ({ commit }, menuOpened) {
      commit('setMenuOpened', menuOpened)
    },
    setSaveFilters ({ commit }, saveFilters) {
      commit('setSaveFilters', saveFilters)
    },
    setCountries ({ commit }, countries) {
      commit('setCountries', countries)
    },
    setOfferTypes ({ commit }, offerTypes) {
      commit('setOfferTypes', offerTypes)
    },
    setPickerOptionsShortcuts ({ commit }, pickerOptionsShortcuts) {
      commit('setPickerOptionsShortcuts', pickerOptionsShortcuts)
    },
    setProduits ({ commit }, produits) {
      commit('setProduits', produits)
    },
    setPopupSfcVue ({ commit }, popupSfcVue) {
      commit('setPopupSfcVue', popupSfcVue)
    },
    setPopupBiensVendusVue ({ commit }, popupBiensVendusVue) {
      commit('setPopupBiensVendusVue', popupBiensVendusVue)
    },
    setSocialNetworkIds ({ commit }, socialNetworkIds) {
      commit('setSocialNetworkIds', socialNetworkIds)
    },
    setSocialNetworkCodenames ({ commit }, socialNetworkCodenames) {
      commit('setSocialNetworkCodenames', socialNetworkCodenames)
    },
    resetFilters ({ commit, state }) {
      if (state.user.saveFilters) {
        return
      }
      // not used : donnees, exports, notifications, productLine
      commit('broadcast/resetPresetFilters')
      commit('contacts/resetPresetFilters')
      commit('contactsList/resetPresetFilters')
      commit('contactsListPosts/resetPresetFilters')
      commit('contactsListVisites/resetPresetFilters')
      commit('contactsListPortals/resetPresetFilters')
      commit('contactsListRapprochementPortals/resetPresetFilters')
      commit('detailContactsPerPortal/resetPresetFilters')
      commit('detailContactsPerPost/resetPresetFilters')
      commit('portals/resetPresetFilters')
      commit('posts/resetPresetFilters')
      commit('postsVo/resetPresetFilters')
      commit('users/resetPresetFilters')
      commit('globalreport/resetPresetFilters')
      commit('portalsSecondaryList/resetPresetFilters')
      commit('postsListImmo/resetPresetFilters')
      commit('postsVo/resetPresetFilters')
    },
    updatedUser ({ state }) {
      const user = state.user
      HTTP_HYPER_ESPACE_BACKEND.put('/users/' + user.id, user)
        .then(response => {
          return response
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
    },
    updateBVOnboarding ({ commit }) {
      commit('SET_STOP_POPUP_BIENS_VENDUS', true)
    }
  }
}
